import styled from 'styled-components';

import JourneyMapModal from './container';

export default styled(JourneyMapModal)`
  height: 600px;
  position: relative;
`;
